export default "/img/NP.22fe775b2f6ab8a779bb9c659591cd76.png";